@for (toast of state.toasts(); track toast.id) {
  <app-toast [item]="toast" (closed)="state.remove(toast.id)" />
}
